// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatWorkflowPromptVocabularyDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { ChatWorkflowPromptPlaceholderDtoGenShape } from "./chat-workflow-prompt-placeholder-dto.gen";
import { ChatWorkflowPromptFieldDtoGenShape } from "./chat-workflow-prompt-field-dto.gen";

export const ChatWorkflowPromptVocabularyDtoGenShape = z.strictObject({
  placeholders: z.array(ChatWorkflowPromptPlaceholderDtoGenShape),
  fields: z.array(ChatWorkflowPromptFieldDtoGenShape),
});
